import { call, put, takeEvery } from "redux-saga/effects";
import {
  FETCH_SERVICES_DELETION_LOGS_REQUEST,
  FETCH_SERVICES_DELETION_LOGS_SUCCESS,
  FETCH_SERVICES_DELETION_LOGS_FAILURE,
} from "./actionTypes";
import { fetchServicesDeletionLogsSuccess, fetchServicesDeletionLogsFailure } from "./actions";
import { getDocs, collection, query, where, doc, updateDoc } from "firebase/firestore";
import { db } from "../../helpers/firebase/firebaseConfig";

function* fetchServicesDeletionLogsSaga() {
  try {
    // Fetch soft-deleted services (where is_deleted === true)
    const q = query(
      collection(db, "service_provider_services"),
      where("is_deleted", "==", true)
    );
    const querySnapshot = yield call(getDocs, q);
    const logs = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
      type: "soft_delete", // Mark as soft delete type
    }));
    yield put(fetchServicesDeletionLogsSuccess(logs));
  } catch (error) {
    yield put(fetchServicesDeletionLogsFailure(error.message));
  }
}

// Restore service by removing soft delete flag
function* restoreServiceSaga(action) {
  try {
    const { serviceId } = action.payload;
    const serviceRef = doc(db, "service_provider_services", serviceId);
    
    yield call(updateDoc, serviceRef, {
      is_deleted: false,
      status: "active",
      restored_at: new Date().toISOString(),
      updated_at: new Date().toISOString()
    });
    
    // Refresh the list
    yield put({ type: "FETCH_SERVICES_DELETION_LOGS_REQUEST" });
  } catch (error) {
    console.error("Restore service error:", error);
  }
}

function* servicesDeletionLogsSaga() {
  yield takeEvery(FETCH_SERVICES_DELETION_LOGS_REQUEST, fetchServicesDeletionLogsSaga);
  yield takeEvery("RESTORE_SERVICE_REQUEST", restoreServiceSaga);
}

export default servicesDeletionLogsSaga;